/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserResponse } from '../../models/get-user-response';

export interface UserServiceGetUser$Params {
  uuid: string;
  discordId?: string;

/**
 * If true, only show the highest tier of each achievement.
 */
  consolidateAchievements?: boolean;
}

export function userServiceGetUser(http: HttpClient, rootUrl: string, params: UserServiceGetUser$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserResponse>> {
  const rb = new RequestBuilder(rootUrl, userServiceGetUser.PATH, 'get');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.query('discordId', params.discordId, {});
    rb.query('consolidateAchievements', params.consolidateAchievements, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserResponse>;
    })
  );
}

userServiceGetUser.PATH = '/api/v3/gateway/user/{uuid}';
